import React, { useContext } from 'react';
import style from './HTTPApiRequestDisplay.scss';
import { Rectangle } from '../../../../PageElements/Rectangle/Rectangle';
import { Text } from '../../../../PageElements/Text';
import { HTTPMethodDisplay } from './HTTPMethodDisplay';
import { RESTPlaygroundOpenButton } from '../../RESTOperationView/RESTPlaygroundOpenButton';
import { StoreContext } from '../../../../../appContext/StoreProvider';

export const HTTPApiRequestDisplay = ({
  method,
  url,
  onOpenPlaygroundClick,
}) => {
  const { store } = useContext(StoreContext);
  const shouldDisplayRestPlaygroundButton =
    !store.viewer?.viewerConfig?.displayOptions?.hideRestPlayground;

  return (
    <Rectangle className={style.httpApiRequestDisplayContainer}>
      <HTTPMethodDisplay method={method} />
      <div className={style.urlContainer}>
        <Text
          dataHook="display-url"
          weight="normal"
          size="medium"
          className={style.urlText}
        >
          {url}
        </Text>

        {shouldDisplayRestPlaygroundButton && (
          <RESTPlaygroundOpenButton
            onOpenPlaygroundClick={onOpenPlaygroundClick}
          />
        )}
      </div>
    </Rectangle>
  );
};
